export enum ButtonSize {
  LARGE = 'vf-btn--lg',
  MEDIUM = 'vf-btn',
  SMALL = 'vf-btn--sm',
}

export enum ButtonVariant {
  PRIMARY = 'vf-btn__primary',
  SECONDARY = 'vf-btn__secondary',
  TERTIARY = 'vf-btn__tertiary',
  QUATERNARY = 'vf-btn__tertiary vf-btn__quaternary',
}
